import { axiosApi } from "../axios";
import { priorityContacts, priorityWorkspaceItem } from "../types/priorityContacts";
import { iManageLoginModal } from "./iManageAuth";

export const getPriorityContacts = async (userId: string): Promise<priorityContacts> => {
  const response = await axiosApi.get<priorityContacts>(`/users/${userId}/priorityContacts`);

  return response.data;
};

export const setPriorityContacts = async (
  userId: string,
  priorityContacts: priorityContacts
): Promise<priorityContacts> => {
  const response = await axiosApi.post<priorityContacts>(`/users/${userId}/priorityContacts`, priorityContacts);

  return response.data;
};



const getValueFromJson = (json: { [key: string]: string }, key: string): string | undefined => {
  return json[key];
};

// Function to handle 401 error and retry the request
const handle401Error = async (error: any) => {
  const hostName = Office.context.mailbox.diagnostics.hostName;
  const email = Office.context.mailbox.userProfile.emailAddress;
  const iManageUrl =getValueFromJson(error.response.data, "iManageUrl");
  const iManageAuthUrl = "https://" + iManageUrl + "&login_hint=" + email + "&auto_submit=true&remember_email=true";

  // Wait for the dialog to close before retrying the request
  await new Promise<void>((resolve) => {
    iManageLoginModal(iManageAuthUrl, hostName, resolve);
  });
  // Retry the original request
  const config = error.config;
  return axiosApi(config);
};

// Add the interceptor to the axiosApi instance
axiosApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.config.url?.includes("/workspaces") && error.response) {
      if (error.response.status === 401) {
      return handle401Error(error);
    }
    else  {
      console.error("iManage Workspaces not found:", error.response.data);
    }
  }
    return Promise.reject(error);
  }
);
export const getWorkspaces = async (userId: string): Promise<priorityWorkspaceItem[]> => {
  const response = await axiosApi.get<priorityWorkspaceItem[]>(`/users/${userId}/workspaces`);

  return response.data;
};